
import React from "react";
import PropTypes from 'prop-types';

/**
 * Informacje o użytkowniku
 */
const UserInfo = ({ user }) => {
    return (
        <>
            {user.firstName} {user.lastName}
        </>
    )
}

UserInfo.propTypes = {
    user: PropTypes.object.isRequired
};

export default UserInfo;